export default __webpack_public_path__ + "static/cta-background-01db3b967e028ae243ff483a05bbbf97.svg";